import type { PhoneBookUser } from '../model/query/usePhoneBook';

function matchesNumber(number: string | null, search: string): boolean {
  if (!number) {
    return false;
  }
  return number.replace(/[\s-]/g, '').includes(search.replace(/[\s-]/g, ''));
}

export function matchesContactSearch(
  user: PhoneBookUser,
  search: string,
): boolean {
  const normalizedSearch = search.trim().toLowerCase();
  if (!normalizedSearch) {
    return true;
  }
  return (
    user.name.toLowerCase().includes(normalizedSearch) ||
    (user.jobTitle ?? '').toLowerCase().includes(normalizedSearch) ||
    matchesNumber(user.phone, normalizedSearch) ||
    matchesNumber(user.mobile, normalizedSearch)
  );
}
